import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OrderImport} from '../../dto/order-import';
import {CurrencyConversionCurrency, CurrencyConversionRateInfo} from '../../dto/currencyConversionCurrency';

@Injectable({
  providedIn: 'root'
})
export class FxRateService {
  readonly apiPath = 'fx-rate/';
  readonly headers = new HttpHeaders({ 'No-Auth': 'True' });
  constructor(
    private http: HttpClient,
  ) { }


  getRate(source: string, target: string, cardType: string, date: string): Observable<CurrencyConversionRateInfo> {

    const params = new HttpParams()
      .set('source', source)
      .set('target', target)
      .set('cardType', cardType)
      .set('date', date);

    return this.http.get(this.apiPath, {params, headers: this.headers}) as Observable<CurrencyConversionRateInfo>;
  }

  getCurrencies(): Observable<CurrencyConversionCurrency[]> {
  return this.http.get(this.apiPath + 'currencies', {headers: this.headers}) as Observable<CurrencyConversionCurrency[]>;
  }
}
